import types from '../../actions/types';
import {
    paginatedResultReducer
} from '../common/paginated_results';
import {
    removeItem
} from '../common/remove-item';
const initialState = {
    loading: false
};

export default function partnersReducer(state = initialState, action) {
    switch (action.type) {
        case types.ADMIN_LOAD_PARTNER.REQUEST:
            return {
                ...state,
                partner: {},
                loading: true
            };

        case types.ADMIN_LOAD_PARTNER.SUCCESS:

            return {
                ...state,
                partner: action.payload,
                loading: false
            };

        case types.SUBMIT_PARTNER.SUCCESS:
            return {
                ...state,
                partner: action.payload,
                loading: false
            };
        case types.DELETE_PARTNER.SUCCESS:
            return {
                ...state,
                partners: {
                    ...state.partners,
                    items: removeItem(state.partners.items, action.payload.id)
                }

            }
        default:
            return {
                ...state,
                partners: paginatedResultReducer(state.partners, types.ADMIN_LOAD_PARTNERS, action)
            };
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/admin/partners.js